import { SR_API_ACTION_UPDATE_MOVE_IN_DATE } from 'api/actionTypes';

export default async function updateMoveInDate({ state, apiClient }, { moveInDate }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_UPDATE_MOVE_IN_DATE,
    state: state,
    payload: {
      moveInDate,
    },
    onSuccess(updatedUser) {
      state.set(['currentUser'], updatedUser);
      state.set(['updateMoveInDate', 'forceMoveInDateUpdate'], false);
    },
    onError(error) {
      throw error;
    },
  });
}
